import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import ProTree from "@/components/login-unit/pro-tree.vue";
import Cookies from "js-cookie";
import _ from "lodash";
import { getRecentUnits } from "@/utils/recent-units";
import { getFavoriteUnits, toggleFavoriteUnit } from "@/utils/unit-favorites";
export default {
  name: "switching-unit",
  components: {
    ProTree
  },
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      searchObj: {
        search: ""
      },
      filteredTreeData: [],
      isSearchFixed: false,
      activeFilter: "ALL",
      recentUnits: [],
      favoriteUnitIds: [],
      debouncedFilterTreeData: null
    };
  },
  computed: {
    _unitIsNone() {
      // 加载单位树时先保留 loading 态，避免接口未返回前误提示没有单位。
      return !this.loading && this.filteredTreeData.length === 0;
    },
    _alreadyUnit() {
      return Cookies.get("unitId");
    },
    _isMoile() {
      return window.innerWidth < 500;
    },
    recentUnitIds() {
      return this.recentUnits.map(unit => unit.unitId);
    },
    _totalUnits() {
      return this.countLeaves(this.filteredTreeData);
    },
    allUnitCount() {
      return this.countLeaves(this.treeData);
    },
    favoriteCount() {
      return this.countMatchingUnits(this.treeData, new Set(this.favoriteUnitIds));
    },
    recentCount() {
      return this.countMatchingUnits(this.treeData, new Set(this.recentUnitIds));
    }
  },
  watch: {
    "searchObj.search": {
      handler() {
        this.debouncedFilterTreeData();
      }
    },
    treeData: {
      handler() {
        this.filterTreeData();
      },
      deep: true,
      immediate: true
    },
    activeFilter() {
      this.filterTreeData();
    },
    favoriteUnitIds() {
      this.filterTreeData();
    },
    recentUnits() {
      this.filterTreeData();
    }
  },
  created() {
    this.debouncedFilterTreeData = _.debounce(() => {
      this.filterTreeData();
    }, 200);
    this.loadCaches();
  },
  mounted() {
    this.handleScroll();
    const scrollContainer = this.$el;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const scrollContainer = this.$el;
    if (scrollContainer) {
      scrollContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    loadCaches() {
      this.recentUnits = getRecentUnits();
      this.favoriteUnitIds = getFavoriteUnits();
    },
    countLeaves(nodes = []) {
      let count = 0;
      const countLeaves = items => {
        items.forEach(node => {
          if (node.children && node.children.length > 0) {
            countLeaves(node.children);
          } else {
            count += 1;
          }
        });
      };
      countLeaves(nodes);
      return count;
    },
    countMatchingUnits(nodes = [], unitIds) {
      let count = 0;
      const walk = items => {
        items.forEach(node => {
          if (node.unitId && unitIds.has(node.unitId)) {
            count += 1;
          }
          if (node.children && node.children.length > 0) {
            walk(node.children);
          }
        });
      };
      walk(nodes);
      return count;
    },
    mapTree(value, arr) {
      const nextTree = [];
      const searchValue = value.toUpperCase();
      arr.forEach(element => {
        let filteredChildren = [];
        if (element.children && element.children.length > 0) {
          filteredChildren = this.mapTree(value, element.children);
        }
        const selfMatch = element.name.toUpperCase().includes(searchValue) || element.code.toUpperCase().includes(searchValue);
        if (selfMatch || filteredChildren.length > 0) {
          nextTree.push({
            ...element,
            children: filteredChildren,
            expand: true
          });
        }
      });
      return nextTree;
    },
    filterTreeByUnitIds(nodes, unitIds) {
      const nextTree = [];
      nodes.forEach(node => {
        var _node$children;
        const filteredChildren = (_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length ? this.filterTreeByUnitIds(node.children, unitIds) : [];
        const selfMatch = node.unitId && unitIds.has(node.unitId);
        if (selfMatch || filteredChildren.length > 0) {
          nextTree.push({
            ...node,
            children: filteredChildren,
            expand: true
          });
        }
      });
      return nextTree;
    },
    filterTreeData() {
      let nextTree = this.searchObj.search ? this.mapTree(this.searchObj.search, this.treeData) : this.treeData;
      if (this.activeFilter === "FAVORITES") {
        nextTree = this.filterTreeByUnitIds(nextTree, new Set(this.favoriteUnitIds));
      }
      if (this.activeFilter === "RECENT") {
        nextTree = this.filterTreeByUnitIds(nextTree, new Set(this.recentUnitIds));
      }
      this.filteredTreeData = nextTree;
    },
    setFilter(filter) {
      this.activeFilter = filter;
    },
    expandAll() {
      const setExpand = (nodes, val) => {
        nodes.forEach(node => {
          this.$set(node, "expand", val);
          if (node.children && node.children.length > 0) {
            setExpand(node.children, val);
          }
        });
      };
      setExpand(this.filteredTreeData, true);
    },
    collapseAll() {
      const setExpand = (nodes, val) => {
        nodes.forEach(node => {
          this.$set(node, "expand", val);
          if (node.children && node.children.length > 0) {
            setExpand(node.children, val);
          }
        });
      };
      setExpand(this.filteredTreeData, false);
    },
    onToggleFavorite(unit) {
      if (!unit || !unit.unitId) return;
      this.favoriteUnitIds = toggleFavoriteUnit(unit.unitId);
    },
    onRecentUnitClick(unit) {
      this.onChangeUnit(unit);
    },
    onLogout() {
      this.$emit("onLogout");
    },
    onChangeUnit(unit) {
      this.$emit("on-change-unit", unit);
    },
    onBack() {
      this.$router.push("/MGT");
    },
    handleScroll() {
      const scrollContainer = this.$el;
      if (scrollContainer) {
        const scrollTop = scrollContainer.scrollTop;
        this.isSearchFixed = scrollTop > 110;
      }
    }
  }
};